// extracted by mini-css-extract-plugin
export var cardHeader = "_sz-0";
export var reorderHandle = "_sz-3";
export var titleArea = "_sz-1";
export var titleAreaWithHandle = "_sz-2";